// Icon names are stored as strings and resolved dynamically by the sidebar/navigation components
// See: src/components/Sidebar.jsx for icon resolution

export const CONSTANTS = {
  PER_PAGE: 15
}

export const DATATABLES_CUSTOM_STYLES = {
  table: {
    style: {
      backgroundColor: '#000000',
      color: '#ffffff',
    },
  },
  headRow: {
    style: {
      backgroundColor: '#AEA36D', // Vegas gold
      color: '#000000',
      fontWeight: 'bold',
      borderBottom: '2px solid #AEA36D',
    },
  },
  headCells: {
    style: {
      backgroundColor: '#AEA36D', // Vegas gold
      color: '#000000',
      fontWeight: 'bold',
      fontSize: '14px',
      paddingLeft: '8px',
      paddingRight: '8px',
    },
  },
  rows: {
    style: {
      backgroundColor: '#000000',
      color: '#ffffff',
      borderBottom: '1px solid #333333',
    },
  },
  cells: {
    style: {
      color: '#ffffff',
      paddingLeft: '8px',
      paddingRight: '8px',
    },
  },
  pagination: {
    style: {
      backgroundColor: '#000000',
      color: '#ffffff',
      borderTop: '1px solid #333333',
    },
    pageButtonsStyle: {
      backgroundColor: 'transparent',
      color: '#AEA36D',
      border: 'none',
      fill: '#AEA36D',
      '&:hover:not(:disabled)': {
        backgroundColor: 'transparent',
        color: '#B8A96F',
        fill: '#B8A96F',
      },
      '&:disabled': {
        backgroundColor: 'transparent',
        color: '#666666',
        fill: '#666666',
      },
    },
  },
  noData: {
    style: {
      backgroundColor: '#000000',
      color: '#ffffff',
    },
  },
};

export const GARAGES = [
    {
      id: 'operations',
      name: 'Operations',
      icon: 'IconSettings',
      lots: [
        { id: 'assignments', name: 'Assignments', icon: 'IconClipboard', component: 'AssignmentCenter', path: '/operations/assignments', requiredBadges: ['captain', 'kot', 'council'] },
        { id: 'brain', name: 'ODV Brain', icon: 'IconTerminal2', component: 'BrainMap', path: '/operations/brain', requiredBadges: ['council'] },
        { id: 'open-assignments', name: 'Open Assignments', icon: 'IconAlertTriangle', component: 'OpenAssignments', path: '/operations/open-assignments', requiredBadges: ['captain', 'kot', 'council'] },
        { id: 'clients', name: 'Clients', icon: 'IconUsers', component: 'ClientManagement', path: '/operations/clients', requiredBadges: ['captain', 'kot', 'council'] },
        { id: 'portal', name: 'Client Portal', icon: 'IconEye', component: 'ClientPortalViewer', path: '/clients/portal', requiredBadges: ['kot', 'council'] },
        { id: 'equipment', name: 'Equipment', icon: 'IconTool', component: 'EquipmentRequestCenter', path: '/admin/equipment', requiredBadges: ['captain', 'kot', 'council'] },
        { id: 'events', name: 'Events', icon: 'IconCalendar', component: 'EventsDashboardMain', path: '/operations/events', requiredBadges: ['captain', 'kot', 'council'] },
        { id: 'gseater', name: 'GSeater', icon: 'IconRun', component: 'GSeaterDashboard', path: '/operations/gseater', requiredBadges: ['captain', 'kot', 'council'] },
        { id: 'incidents', name: 'Incidents', icon: 'IconAlertCircle', component: 'IncidentReportsCenter', path: '/operations/incidents', requiredBadges: ['captain', 'kot', 'council'] },
        { id: 'locations', name: 'Locations', icon: 'IconMapPin', component: 'LocationManager', path: '/operations/locations', requiredBadges: ['captain', 'kot', 'council'] },
        { id: 'products', name: 'Products', icon: 'IconPackage', component: 'products', path: '/operations/products', requiredBadges: ['captain', 'kot', 'council'] },
        { id: 'services', name: 'Services', icon: 'IconCalendarStats', component: 'ServiceDashboard', path: '/operations/services', requiredBadges: ['captain', 'kot', 'council'] },
        { id: 'shuttle', name: 'Shuttles', icon: 'IconBus', component: 'FleetManager', path: '/operations/shuttle', requiredBadges: ['captain', 'kot', 'council'] },
        { id: 'world', name: 'ODV World', icon: 'IconWorld', component: 'ODVWorld', path: '/operations/world', requiredBadges: ['captain', 'kot', 'council'] },
        { id: 'pay-change-requests', name: 'Pay Change Requests', icon: 'IconCurrencyDollar', component: 'PayChangeRequests', path: '/operations/pay-change-requests', requiredBadges: ['captain', 'kot', 'council'] },
        { id: 'round-table', name: 'Round Table', icon: 'IconUsers', component: 'RoundTable', path: '/operations/round-table', requiredBadges: ['captain', 'kot', 'council'] }
      ]
    },
    {
      id: 'finance',
      name: 'Finance',
      icon: 'IconCurrencyDollar',
      lots: [
        { id: 'finance', name: 'Finance Hub', icon: 'IconBook', component: 'FinanceHub', path: '/finance', requiredBadges: ['council'], description: 'Consolidated stream, chart of accounts, P&L, and invoice schedule' },
        { id: 'dashboard', name: 'Dashboard', icon: 'IconChartLine', component: 'FinanceDashboardEnhanced', path: '/finance/dashboard', requiredBadges: ['council'] },
        { id: 'bookkeeping', name: 'Books', icon: 'IconReceipt', component: 'BookkeepingLot', path: '/finance/bookkeeping', requiredBadges: ['council'] },
        // Reports is a tab inside Bookkeeping, not a separate lot
        { id: 'invoices', name: 'Invoices', icon: 'IconReceipt', component: 'InvoiceDashboard', path: '/finance/invoices', requiredBadges: ['council'] },
        { id: 'collections', name: 'Collections', icon: 'IconCalendarStats', component: 'CollectionsDashboard', path: '/finance/collections', requiredBadges: ['council'] },
        { id: 'disbursements', name: 'Settlements', icon: 'IconCash', component: 'DisbursementsWithTabs', path: '/finance/disbursements', requiredBadges: ['council'] },
        { id: 'disbursements-lot', name: 'Disbursements Legacy', icon: 'IconCash', component: 'DisbursementsLot', path: '/finance/disbursements-lot', requiredBadges: ['council'], description: 'Legacy split-screen payout surface for review; do not execute from this page' },
        { id: 'pay-issues', name: 'Pay Issues', icon: 'IconAlertCircle', component: 'PayIssuesTab', path: '/finance/pay-issues', requiredBadges: ['council'], description: 'Valet pay discrepancy review queue' },
        { id: 'tax-tracking', name: 'Tax Tracking', icon: 'IconClipboard', component: 'TaxTrackingDashboard', path: '/finance/tax-tracking', requiredBadges: ['council'] },
        { id: 'breaking-bread', name: "Breakin' Bread", icon: 'IconCoin', component: 'BreakingBread', path: '/finance/breaking-bread', requiredBadges: ['council'] },
      ]
    },
    {
      id: 'leadership',
      name: 'Leadership',
      icon: 'IconCrown',
      lots: [
        { id: 'leadership', name: 'ODV Leadership', icon: 'IconCrown', component: 'LeadershipManagement', path: '/leadership', requiredBadges: ['admin-access', 'council'] },
      ]
    },
    {
      id: 'partners',
      name: 'Partners',
      icon: 'IconBriefcase',
      description: 'Operator-contractor partnerships (4u Valet, future operators)',
      lots: [
        { id: 'index', name: 'Partners', icon: 'IconBriefcase', component: 'PartnersLot', path: '/partners', requiredBadges: ['council', 'kot'] },
        { id: '4u', name: '4u Valet', icon: 'IconBriefcase', component: 'PartnersLot', path: '/partners/4u', requiredBadges: ['council', 'kot'] }
      ]
    },
    {
        id: 'hr',
        name: 'HR',
        icon: 'IconUsers',
        lots: [{
                id: 'valets',
                name: 'Valets',
                icon: 'IconUserPlus',
                component: 'index',
                path: '/valets',
                requiredBadges: ['captain', 'kot', 'council']
            },
            {
                id: 'badges',
                name: 'Badges',
                icon: 'IconAward',
                component: 'BadgesLot',
                path: '/hr/badges',
                requiredBadges: ['council']
            },
            // Note: Gamification Demo is a direct route in App.jsx at /demo/gamification
            {
                id: 'reliability',
                name: 'Reliability',
                icon: 'IconShieldCheck',
                component: 'ReliabilityTab',
                path: '/hr/valets/reliability',
                requiredBadges: ['captain', 'kot', 'council']
            },
            {
                id: 'ratings',
                name: 'Ratings',
                icon: 'IconStar',
                component: 'ratings',
                path: '/hr/ratings',
                requiredBadges: ['captain', 'kot', 'council']
            },
            {
                id: 'recruits',
                name: 'Recruits',
                icon: 'IconUserSearch',
                component: 'RecruitingLot',
                path: '/recruiting',
                // Doug 2026-08-18: "open up the recruits board to captains and kots so they
                // can participate in recruiting." Board carries pipeline data only (no
                // comp/margin/client rates) — safe under the contractor money firewall.
                // Certification gates stay in the cert flow (staging + badges), untouched.
                requiredBadges: ['captain', 'kot', 'council']
            },
            {
                id: 'papercheck',
                name: 'Paperwork Check',
                icon: 'IconFileCheck',
                component: 'PaperCheckDashboard',
                path: '/hr/papercheck',
                requiredBadges: ['kot', 'council']
            },
            {
                // Sean 2026-10-01: every driver's license and MVR at once, to send to
                // insurance. The hr-licenses badge can only be held by five named people
                // (DB lock); the edge function re-checks it, so this gate only hides the link.
                id: 'licenses',
                name: 'Licenses & MVRs',
                icon: 'IconShieldCheck',
                component: 'LicensesGallery',
                path: '/hr/licenses',
                requiredBadges: ['hr-licenses']
            },
            {
                // Stephen 2026-10-12: the prospecting pipeline (formerly "CRM" in its own
                // Sales garage) lives under HR as Marketing. Council only — strictBadges
                // opts it out of the KOT full-HR-garage pass in LotsSidebar. The id stays
                // 'crm' because ParkingLot loads /lots/<id>/ — 'marketing' is a different lot.
                id: 'crm',
                name: 'Marketing',
                icon: 'IconRocket',
                component: 'index',
                path: '/marketing',
                requiredBadges: ['council'],
                strictBadges: true
            }
        ]
    },
    {
      id: 'valet',
      name: 'Valet',
      icon: 'IconRun',
      lots: [
        { id: 'dashboard', name: 'Dashboard', icon: 'IconChartLine', component: 'ValetDashboard', path: '/valet', requiredBadges: ['valet-certified'] },
        { id: 'leaderboard', name: 'Leaderboard', icon: 'IconTrophy', component: 'ValetLeaderboard', path: '/valet/leaderboard', requiredBadges: ['valet-certified'] },
        { id: 'assignments', name: 'My Assignments', icon: 'IconClipboard', component: 'ValetAssignments', path: '/valet/assignments', requiredBadges: ['valet-certified'] },
        { id: 'wallet', name: 'Wallet', icon: 'IconCash', component: 'ValetWallet', path: '/valet/wallet', requiredBadges: ['valet-certified'] },
        { id: 'badges', name: 'My Badges', icon: 'IconAward', component: 'ValetBadges', path: '/valet/badges', requiredBadges: ['valet-certified'] },
        { id: 'school', name: 'School of Parkology', icon: 'IconStar', component: 'SchoolOfParkology', path: '/valet/school', requiredBadges: ['valet-certified'] },
        { id: 'apparel', name: 'ODV Apparel', icon: 'IconShirt', component: 'ApparelStore', path: '/valet/apparel', requiredBadges: ['valet-certified'] },
        { id: 'equipment', name: 'Equipment Requests', icon: 'IconTool', component: 'ValetEquipmentRequests', path: '/valet/equipment', requiredBadges: ['valet-certified'] }
      ]
    },
    {
      id: 'branding',
      name: 'Branding',
      icon: 'IconPalette',
      lots: [
        { id: 'apparel', name: 'Apparel Admin', icon: 'IconShirt', component: 'ApparelAdmin', path: '/branding/apparel', requiredBadges: ['apparel-boss', 'kot', 'council', 'admin-access'] },
        { id: 'proposals', name: 'Proposals', icon: 'IconBriefcase', component: 'proposals', path: '/branding/proposals', requiredBadges: ['council'] }
      ]
    },
    {
      id: 'mailroom',
      name: 'Mail Room',
      icon: 'IconMail',
      lots: [
        { id: 'index', name: 'Mail Room', icon: 'IconMail', component: 'Mailroom', path: '/mailroom', requiredBadges: ['admin-access', 'kot', 'council'], lotModule: 'mailroom' },
      ]
    },
    {
      id: 'comms-center',
      name: 'Communications',
      icon: 'IconSpeakerphone',
      lots: [
        { id: 'index', name: 'Timeline', icon: 'IconSpeakerphone', component: 'CommsDashboard', path: '/comms', requiredBadges: ['kot', 'council'] },
        { id: 'phone', name: 'Phone', icon: 'IconPhone', component: 'PhoneLot', path: '/phone', requiredBadges: ['kot', 'council'] },
        { id: 'sms', name: 'SMS Center', icon: 'IconMessage', component: 'SMSCenter', path: '/sms', requiredBadges: ['odv-phone', 'admin-phones'] },
      ]
    },
    {
      id: 'qc',
      name: 'Quality Control',
      icon: 'IconClipboardCheck',
      lots: [
        { id: 'index', name: 'Quality Control', icon: 'IconClipboardCheck', component: 'QCDashboard', path: '/qc', requiredBadges: ['kot', 'council'] },
      ]
    },
    {
      id: 'agents',
      name: 'Agents',
      icon: 'IconRobot',
      lots: [
        { id: 'index', name: 'Agents', icon: 'IconRobot', component: 'AgentCommandCenter', path: '/agents', requiredBadges: ['council'] },
        { id: 'voice-analytics', name: 'Voice Analytics', icon: 'IconSpeakerphone', component: 'VoiceAnalyticsDashboard', path: '/agents/voice-analytics', requiredBadges: ['council'] },
      ]
    },
    {
      id: 'admin',
      name: 'Admin',
      icon: 'IconShield',
      lots: [
        { id: 'claims', name: 'Claims', icon: 'IconAlertCircle', component: 'ClaimsCenter', path: '/admin/claims', requiredBadges: ['admin-access', 'kot', 'council'] },
        { id: 'contracts', name: 'Contracts', icon: 'IconReceipt', component: 'Contracts', path: '/admin/contracts', requiredBadges: ['admin-access'] },
        { id: 'users', name: 'Users', icon: 'IconUsers', path: '/admin/users', requiredBadges: ['admin-access'] },
        { id: 'client-portal', name: 'Client Portal Admin', icon: 'IconShield', component: 'ClientPortalAdminDashboard', path: '/admin/client-portal', requiredBadges: ['admin-access'] },
        { id: 'meetings', name: 'Meetings', icon: 'IconCalendarStats', component: 'MeetingsLot', path: '/admin/meetings', requiredBadges: ['admin-access'] },
        { id: 'matrix', name: 'ODV Matrix', icon: 'IconTerminal2', component: 'ODVMatrix', path: '/admin/matrix', requiredBadges: ['admin-access', 'council'] },
        { id: 'tasks', name: 'Task Bucket', icon: 'IconList', component: 'TaskBucket', path: '/admin/tasks', requiredBadges: [] }
      ]
    },
    // REMOVED: client-portal garage - Use /portal/* routes instead (public client portal)
    {
      id: 'knowledge-base',
      name: 'Knowledge Base',
      icon: 'IconBook',
      lots: [
        { id: 'browse', name: 'Browse', icon: 'IconBook', component: 'KnowledgeBaseDashboard', path: '/knowledge-base', requiredBadges: ['valet-certified', 'captain', 'kot', 'council', 'admin-access'] },
        { id: 'suggestions', name: 'Suggestions', icon: 'IconBulb', component: 'KnowledgeBaseDashboard', path: '/knowledge-base/suggestions', requiredBadges: ['valet-certified', 'captain', 'kot', 'council', 'admin-access'] }
      ]
    }
  ];
